import {Box, Heading, Paragraph} from 'grommet'

export default function NoURLs() {
    return (
        <Box>
            <Heading level="3">
                Your URLs
            </Heading>
            <Paragraph>There are no URLs associated with your account, go ahead and create one!</Paragraph>
        </Box>
    )
}